export default __webpack_public_path__ + "static/media/step_1.a3e2ace5.svg";